import { Button, DotProgress, Modal } from "@xola/ui-kit";
import { SecondaryButton } from "common";
import React, { useState } from "react";
import { Except } from "type-fest";
import { Card } from "../../types/Card";
import { Tutorial } from "../../types/Tutorial";
import { Loader } from "../Loader";
import { CardDisplay } from "./CardDisplay";

interface TutorialModalProps {
    card?: Card;
    tutorial: Tutorial;
    isOpen: boolean;
    onClose: () => void;
}

export const TutorialModal = ({ card, tutorial, isOpen, onClose }: TutorialModalProps) => {
    return (
        <Modal
            isOpen={isOpen}
            size="medium"
            position="bottomRight"
            className="no-translate !max-h-[70vw] !max-w-105"
            onClose={onClose}
        >
            <ModalContent card={card} tutorial={tutorial} onClose={onClose} />
        </Modal>
    );
};

const ModalContent = ({ card, tutorial, onClose }: Except<TutorialModalProps, "isOpen">) => {
    const initialIndex = card ? tutorial.cards.findIndex((c) => c.id === card.id) : 0;
    const [activeCardIndex, setActiveCardIndex] = useState(initialIndex);
    const activeCard = tutorial.cards[activeCardIndex] ?? tutorial.cards[0];
    const isFirst = activeCardIndex === 0;
    const isLast = activeCardIndex === tutorial.cards.length - 1;
    const totalCount = tutorial.cards.length ?? 0;

    if (!activeCard) {
        return <Loader />;
    }

    const handleNext = () => {
        setActiveCardIndex((previous: number) => {
            return isLast ? 0 : previous + 1;
        });
    };

    const handleBack = () => {
        setActiveCardIndex((previous: number) => {
            return activeCardIndex === 0 ? 0 : previous - 1;
        });
    };

    return (
        <>
            <Modal.Header description={activeCard?.description} className="!w-full">
                {activeCard.name}
            </Modal.Header>
            <Modal.Body className="">
                <CardDisplay card={activeCard} />
            </Modal.Body>
            <Modal.Footer className="flex w-full justify-between">
                {!isFirst && <SecondaryButton onClick={handleBack}>Back</SecondaryButton>}
                <DotProgress current={activeCardIndex} total={totalCount} className={isFirst && "ml-20"} />
                {isLast ? <Button onClick={onClose}>Done</Button> : <Button onClick={handleNext}>Next</Button>}
            </Modal.Footer>
        </>
    );
};
